module.exports = __webpack_public_path__ + "static/images/step7.359bf5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/step/step7.png
// module id = pjjA
// module chunks = 1